import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useDocsContext() {
  const route = useRoute()

  const isPublic = computed<boolean>(() => {
    return typeof route.name === 'string' && route.name.startsWith('public.docs.')
  })

  const base = computed<string>(() => {
    return isPublic.value ? '/docs' : '/organizer/docs'
  })

  return { base, isPublic }
}
